export default "__VITE_ASSET__c7d0508e__"